import * as io from 'io-ts';
import { validString, nullableNumber, numberInRange, boolean } from '@shared/core/types/common';
import { cartLogoutModeEnum, clearOnIdleTriggerModeEnum, clearOnIdleUserTypeEnum } from '@shared/core/types/consts';

const baseDefinition: io.MixedObject<OLO.Config.Cart.Base> = {
    header: validString,
    body: validString,
};

const clearOnLogoutModalDefinition: io.MixedObject<OLO.Config.Cart.UI> = {
    ...baseDefinition,
    yesButtonText: validString,
    noButtonText: validString,
};

const clearOnIdleModalDefinition: io.MixedObject<OLO.Config.Cart.UI> = {
    ...baseDefinition,
    yesButtonText: validString,
    noButtonText: validString,
};

const clearOnIdleDefinition: io.MixedObject<OLO.Config.Cart.ClearOnIdle> = {
    enabled: boolean,
    targetUserType: clearOnIdleUserTypeEnum,
    triggerMode: clearOnIdleTriggerModeEnum,
    timeoutInMinutes: numberInRange(1),
    modal: io.type(clearOnIdleModalDefinition),
};

const rootDefinition: io.MixedObject<OLO.Config.Cart> = {
    checkoutMaxCartItemsLines: nullableNumber,
    emptyCartBody: validString,
    emptyCartButton: validString,
    clearOnLogoutMode: cartLogoutModeEnum,
    clearOnLogoutModal: io.type(clearOnLogoutModalDefinition),
    clearOnIdle: io.type(clearOnIdleDefinition),
};

export const cartSchema = io.type(rootDefinition);
